/**
 * Frontend mirror of services/diaper-ui/src/auth/capabilities.ts.
 * Registers the role->capability map with @nova-integration/auth so the
 * shared LayoutShell, useCapability hook and authStore.can() can do
 * role-based access checks without each component re-importing the map.
 *
 * Keep in sync with the backend file. The backend is the source of truth.
 */
import { registerCapabilities } from '@nova-integration/ui-shared';

export const APP_ID = 'diaper-ui';

export type DiaperUiRole = 'viewer' | 'operator' | 'admin';

export type DiaperUiCapability =
  | 'diaper.sessions.read'
  | 'diaper.sessions.create'
  | 'diaper.sessions.close'
  | 'diaper.events.read'
  | 'diaper.nova.proxy'
  | 'diaper.accounts.read'
  | 'diaper.simulator.send'
  | 'diaper.clip.replace'
  | 'diaper.clip.lifetime'
  | 'diaper.clip.search'
  | 'diaper.clip.inspect'
  | 'diaper.diaper-models.read'
  | 'diaper.away.toggle';

const VIEWER: DiaperUiCapability[] = [
  'diaper.sessions.read',
  'diaper.events.read',
  'diaper.nova.proxy',
  'diaper.accounts.read',
  'diaper.diaper-models.read',
  'diaper.clip.lifetime',
  'diaper.clip.search',
  'diaper.clip.inspect',
];

const OPERATOR: DiaperUiCapability[] = [
  ...VIEWER,
  'diaper.sessions.create',
  'diaper.sessions.close',
  'diaper.simulator.send',
  'diaper.clip.replace',
  'diaper.away.toggle',
];

const ADMIN: DiaperUiCapability[] = [...OPERATOR];

registerCapabilities(APP_ID, {
  viewer: VIEWER,
  operator: OPERATOR,
  admin: ADMIN,
});
